import React from 'react';
import '../scss/style.scss';
import Link from 'gatsby-link';

export default function Layout({children, header, hideNavigation, next}) {

  return <div className="site">
    {hideNavigation || (
      <nav className="site-nav">
        <div className="site-nav-brand">
          <Link to={'/'}>
            <img className="site-nav-logo" alt="Néstor Osuna" src={require('/src/images/logoNestor.png').default} />
          </Link>
        </div>
        {next && (
          <div className="site-nav-next">
            <Link to={next} className="site-nav-next-link">Next <span className="site-nav-next-arrow">&rarr;</span></Link>
          </div>
        )}
      </nav>
    )}
    {header && (
      <header className="site-header">
        <h1 className="site-header-title">{typeof header === 'string' ? header : header}</h1>
      </header>
    )}
    <main className="site-main">{children}</main>
    <footer className="site-footer">
      <div className="site-footer-info">
        <a href="mailto:nestor.osuna.2014@gmail.com">nestor.osuna.2014@gmail.com</a>
        <a href="https://www.instagram.com/nestorosuna_">Instagram</a>
        <a href="https://www.linkedin.com/in/nestor-osuna-41332110">LinkedIn</a>
      </div>
      <button
        className="site-footer-top"
        onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        aria-label="Back to top"
      >
        &uarr;
      </button>
    </footer>
  </div>;
}
